import i18n from 'i18next';
import { pageUrls } from 'globalconfig/constants/keys';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';

export const tabs = {
  tenantTabs: {
    [SERVICE_PROVIDERS.SPIREON]: [
      {
        name: i18n.t('leftMenu.DOTAudit'),
        value: null,
        url: pageUrls.fmcsaLogs,
      },
    ],
    default: [
      {
        name: i18n.t('logs.addLogHeader'),
        value: null,
        url: pageUrls.logsAdd,
      },
      {
        name: i18n.t('logs.archiveLogsHeader'),
        value: null,
        url: pageUrls.archiveLogsList,
      },
    ],
  },
};
